
import {  Dialog, DialogContent } from "@mui/material"
import PaperComponent from "components/PaperComponent"
import { DialogHeader } from "components/dialog/DialogHeader"
import React from "react"
import SparePartManagement from "../SparePartManagement/SparePartManagement"

const SparePartManagementDialog = ({ dialogOpen, setDialogOpen, onFinish }) => {
  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='xl'
    >
      <DialogHeader
        handleDialogClose={() => setDialogOpen(false)}
        title="การจัดการอะไหล่"
        onDeleteClick={null}
      />
      <DialogContent sx={{ height: 650 }}>
        <SparePartManagement onFinish={onFinish} />
      </DialogContent>
    </Dialog>
  )
}

export default React.memo(SparePartManagementDialog)
